import './ui/styles.css';
import { initI18n } from './i18n';
import { App } from './ui/app';

document.addEventListener('DOMContentLoaded', async () => {
  initI18n();

  const container = document.getElementById('app');
  if (!container) {
    throw new Error('Root #app container element not found');
  }

  const app = new App(container);
  await app.init();
});
